import React, { useState } from 'react';
import { message } from 'antd';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import api from '../../../system/client/src/services/api';

const ResetPasswordPage = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token') || '';

    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [loading, setLoading] = useState(false);
    const [failed, setFailed] = useState(false);

    const onSubmit = async (e) => {
        e.preventDefault();
        if (!token) {
            message.error('This reset link is missing its token.');
            setFailed(true);
            return;
        }
        if (password.length < 8) {
            message.error('Password must be at least 8 characters.');
            return;
        }
        if (password !== confirm) {
            message.error('Passwords do not match.');
            return;
        }
        setLoading(true);
        try {
            await api.post('auth/reset-password', { token, password });
            message.success('Password reset — you can sign in now.');
            navigate('/login');
        } catch (error) {
            console.error('Reset password error:', error);
            message.error(
                error.response?.data?.message ||
                    'This reset link is invalid or has expired.'
            );
            setFailed(true);
        } finally {
            setLoading(false);
        }
    };

    return (
        <section className="fs-auth-card">
            <div className="fs-auth-head">
                <span className="kicker">Reset password</span>
                <h1>Set a new password.</h1>
                <p>Choose a new password for your account.</p>
            </div>

            <form onSubmit={onSubmit} noValidate>
                <div className="form-field">
                    <label htmlFor="password">New password</label>
                    <input
                        id="password"
                        type="password"
                        autoComplete="new-password"
                        required
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="At least 8 characters"
                    />
                </div>

                <div className="form-field">
                    <label htmlFor="confirm">Confirm new password</label>
                    <input
                        id="confirm"
                        type="password"
                        autoComplete="new-password"
                        required
                        value={confirm}
                        onChange={(e) => setConfirm(e.target.value)}
                        placeholder="••••••••"
                    />
                </div>

                <div className="fs-auth-actions">
                    <button
                        type="submit"
                        className="btn btn-primary btn-block"
                        disabled={loading}
                    >
                        {loading ? 'Saving…' : (
                            <>Reset password <span className="arrow">→</span></>
                        )}
                    </button>
                </div>
            </form>

            <p className="fs-auth-switch">
                {failed ? (
                    <>Link expired? <Link to="/forgot-password">Request a new one.</Link></>
                ) : (
                    <Link to="/login">Back to sign in.</Link>
                )}
            </p>
        </section>
    );
};

export default ResetPasswordPage;
